import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "hero" };
const _hoisted_2 = ["src"];
const _hoisted_3 = { class: "hero__tagline-label" };
const _hoisted_4 = { class: "hero__tagline-title" };
const _hoisted_5 = { class: "hero__tagline-sub" };
const _hoisted_6 = { class: "hero__socials-label" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("h1", {
            class: "hero__bg-text",
            style: _normalizeStyle(_ctx.bgTextStyle)
        }, _toDisplayString(_ctx.greeting), 5),
        _createElementVNode("img", {
            src: _ctx.heroImage,
            alt: "",
            class: "hero__image",
            style: _normalizeStyle(_ctx.imageStyle)
        }, null, 12, _hoisted_2),
        _createElementVNode("div", {
            class: "hero__tagline",
            style: _normalizeStyle(_ctx.taglineStyle)
        }, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('hero.taglineLabel')), 1),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('hero.taglineTitle')), 1),
            _createElementVNode("p", _hoisted_5, [
                _createTextVNode(_toDisplayString(_ctx.$t('hero.taglineSubLine1')), 1),
                _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                _createTextVNode(_toDisplayString(_ctx.$t('hero.taglineSubLine2')), 1)
            ])
        ], 4),
        _createElementVNode("div", {
            class: "hero__socials",
            style: _normalizeStyle(_ctx.taglineStyle)
        }, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('hero.socialsLabel')), 1),
            _cache[1] || (_cache[1] = _createStaticVNode("<a href=\"https://www.instagram.com/travellingdominika/\" class=\"hero__socials-link\" target=\"_blank\" rel=\"noopener noreferrer\" data-v-3c28f74c><svg class=\"hero__socials-icon\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\" data-v-3c28f74c><rect x=\"2\" y=\"2\" width=\"20\" height=\"20\" rx=\"5\" ry=\"5\" data-v-3c28f74c></rect><path d=\"M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z\" data-v-3c28f74c></path><line x1=\"17.5\" y1=\"6.5\" x2=\"17.51\" y2=\"6.5\" data-v-3c28f74c></line></svg> @travellingdominika </a><a href=\"mailto:dominikatrunowicz@gmail.com\" class=\"hero__socials-link\" data-v-3c28f74c><svg class=\"hero__socials-icon\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\" data-v-3c28f74c><path d=\"M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z\" data-v-3c28f74c></path><polyline points=\"22,6 12,13 2,6\" data-v-3c28f74c></polyline></svg> dominikatrunowicz@gmail.com </a>", 2))
        ], 4)
    ]));
}
